<template>
  <div class="general-content margin-xl-top margin-xl-bottom">
    <div
      v-if="articleLayout === false"
      class="loading flex-middle flex-center"
      style="min-height: 50vh">
      <spinner :size="5"></spinner>
    </div>
    <general-article-view
      v-if="articleLayout === 'general'"
      :article="article"></general-article-view>

    <about-article-view
      v-if="articleLayout === 'about'"
      :article="article"></about-article-view>
    <blog-article-view
      v-if="articleLayout === 'blog'"
      :related-articles="relatedArticles"
      :article="article"></blog-article-view>
    <blog-article-view
      v-if="articleLayout === 'newsFlash' || articleLayout === 'newsflash'"
      :related-articles="relatedArticles"
      :article="article"></blog-article-view>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import { useStore } from "vuex";
import { computed } from "vue";
import asyncComponentFactory from "@/client/extensions/modules/asyncComponentFactory";
export default {
  components: {
    GeneralArticleView: asyncComponentFactory("views/article/General.vue", true),
    AboutArticleView: asyncComponentFactory("views/article/About.vue", true),
    BlogArticleView: asyncComponentFactory("views/article/Blog.vue", true),
  },
  layout: {
    component: "default",
    props: {},
  },
  middleware: {},
  props: {
    articleAlias: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props, useStore());

    return {
      asyncOps,
      asyncOpsReady,
      asyncStatus,

    };
  },
  meta: {
    title: "ag.generalContent.generalMetaTitle",
    description: "ag.generalContent.generalMetaDescription",
  },
  data() {
    return {
      article: false,
      relatedArticles: false,

      asyncData: {
        article: {
          target: computed(() => `content/article/${this.articleAlias}`),
          data: {
            fetchAdditionalItems: true,
            // lookupField: "alias",
          },
          options: {
            dataMutator: (incomingData) => {
              if (incomingData.related) {
                this.relatedArticles = incomingData.related;
              }
              return incomingData.item;
            },
            errorHandler: 404,
          },
        },
      },
    };
  },
  computed: {
    articleLayout() {
      if (!this.article) {
        return false;
      }

      return this.article.layout;
    },
  },
  watch: {},
  mounted() {},
  methods: {
   // updateMetaByState() {
   //   if (this.article) {
    //    this.meta.title = this.article.title;
    //  }
   // },
  },
};
</script>
<style lang="scss"></style>
